(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fixfone-product-specs"]) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ff-tabs]').forEach(function (root) {
    var tabs = root.querySelectorAll('.ff-specs__tab');
    var panels = root.querySelectorAll('.ff-specs__panel');
    if (!tabs.length) return;

    function activate(name) {
      tabs.forEach(function (t) {
        t.classList.toggle('ff-specs__tab--active', t.dataset.tab === name);
        t.setAttribute('aria-selected', t.dataset.tab === name ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('ff-specs__panel--active', p.dataset.panel === name);
      });
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.dataset.tab); });
    });

    // ativar o primeiro separador disponível
    activate(tabs[0].dataset.tab);
  });

  // Colapsa a tabela de especificações longa
  var body = document.getElementById('ff-specs-body');
  var wrap = document.getElementById('ff-specs-more-wrap');
  var btn = document.getElementById('ff-specs-more');
  if (body && wrap && btn) {
    var LIMIT = 520;
    if (body.scrollHeight > LIMIT) {
      body.classList.add('is-collapsed');
      wrap.hidden = false;
    }
    btn.addEventListener('click', function () {
      var collapsed = body.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', String(!collapsed));
      btn.querySelector('[data-more]').hidden = !collapsed;
      btn.querySelector('[data-less]').hidden = collapsed;
      if (collapsed) body.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fixfone-reparacao-marca"]) return;
  try {
    
(function () {
  var btn = document.getElementById('ffrp-wa-btn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var v = function (id) {
      var el = document.getElementById(id);
      return el && el.value ? el.value.trim() : '';
    };
    var linhas = [
      'Olá! Gostaria de pedir um orçamento de reparação:',
      '',
      '• Marca: ' + (v('ffrp-marca') || '—'),
      '• Modelo: ' + (v('ffrp-modelo') || '—'),
      '• Tipo de reparação: ' + (v('ffrp-avaria') || '—'),
      '• Estado: ' + (v('ffrp-estado') || '—'),
      '• Nome: ' + (v('ffrp-nome') || '—'),
      '• Contacto: ' + (v('ffrp-tel') || v('ffrp-email') || '—')
    ];
    var obs = v('ffrp-obs');
    if (obs) linhas.push('• Observações: ' + obs);
    linhas.push('', 'Envio já fotos do equipamento nesta conversa.');
    var url = 'https://wa.me/351915858598?text=' + encodeURIComponent(linhas.join('\n'));
    window.open(url, '_blank', 'noopener');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fixfone-reparacoes"]) return;
  try {
    
(function () {
  var btn = document.getElementById('ffrp-wa-btn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var v = function (id) {
      var el = document.getElementById(id);
      return el && el.value ? el.value.trim() : '';
    };
    var linhas = [
      'Olá! Gostaria de pedir um orçamento de reparação:',
      '',
      '• Marca: ' + (v('ffrp-marca') || '—'),
      '• Modelo: ' + (v('ffrp-modelo') || '—'),
      '• Tipo de reparação: ' + (v('ffrp-avaria') || '—'),
      '• Estado: ' + (v('ffrp-estado') || '—'),
      '• Nome: ' + (v('ffrp-nome') || '—'),
      '• Contacto: ' + (v('ffrp-tel') || v('ffrp-email') || '—')
    ];
    var obs = v('ffrp-obs');
    if (obs) linhas.push('• Observações: ' + obs);
    linhas.push('', 'Envio já fotos do equipamento nesta conversa.');
    var url = 'https://wa.me/351915858598?text=' + encodeURIComponent(linhas.join('\n'));
    window.open(url, '_blank', 'noopener');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fixfone-servicos"]) return;
  try {
    
// Compõe a mensagem WhatsApp com os dados do formulário de retoma
(function () {
  var btn = document.getElementById('ffsv-wa-btn');
  if (!btn) return;
  btn.addEventListener('click', function () {
    var v = function (id) {
      var el = document.getElementById(id);
      return el && el.value ? el.value.trim() : '';
    };
    var linhas = [
      'Olá! Gostaria de pedir uma avaliação de retoma:',
      '',
      '• Marca: ' + (v('ffsv-marca') || '—'),
      '• Modelo: ' + (v('ffsv-modelo') || '—'),
      '• Estado: ' + (v('ffsv-estado') || '—'),
      '• Nome: ' + (v('ffsv-nome') || '—'),
      '• Contacto: ' + (v('ffsv-tel') || v('ffsv-email') || '—')
    ];
    var obs = v('ffsv-obs');
    if (obs) linhas.push('• Observações: ' + obs);
    linhas.push('', 'Envio já as fotos do equipamento nesta conversa.');
    var url = 'https://wa.me/351915858598?text=' + encodeURIComponent(linhas.join('\n'));
    window.open(url, '_blank', 'noopener');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
